export default __webpack_public_path__ + "info-large.png";